import React from 'react'
import { connect } from 'react-redux'
import { Redirect, Link } from 'react-router-dom'
import shortid from 'shortid'

// Material UI
import Collapse from '@material-ui/core/Collapse';
import Divider from '@material-ui/core/Divider';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import InputLabel from '@material-ui/core/InputLabel';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';
import { MuiThemeProvider } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Select from '@material-ui/core/Select';
import Typography from '@material-ui/core/Typography';
import Hidden from '@material-ui/core/Hidden';

// Custom Inputs
import CustomOutlinedButton from './Mui/CustomOutlinedButton';
import StyledRadio from './inputs/StyledRadio'
import TextInput from './inputs/TextInput'
import FormSelect from './inputs/FormSelect'
import MultiSelect from './inputs/MultiSelect'

// Custom Views
import CustomDialog from './inputs/CustomDialog'
import InnerBar from './InnerBar';
import MetaBox from './inputs/MetaBox'
import QuestionPreview from './QuestionPreview'
import AudioSubForm from './AudioSubForm'
import ImageSubForm from './ImageSubForm'

import {
  is_logged_on,
  is_validating,
  theme
 } from "../helpers"

import {
  LocalForm,
  Control,
  actions,
  track
} from 'react-redux-form'

import {
  isRequired,
  isNumeric
} from "../validators"

import {
  get_question,
  question_audio,
  question_audio_request,
  question_image,
  question_image_request,
  preferences_index,
  create_question,
  update_question,
  reset_question,
  trash_question,
  clear_question,
  upload_audio,
  upload_image,
  reset_progress
} from '../actions'

const localstyles = {
  toolbar: theme.mixins.toolbar,
  nested: {
    paddingLeft: theme.spacing.unit * 4,
  },
  listItems: {
    paddingTop: '20px',
    paddingBottom: '20px',
  },
  iconbutton: {
    disabled: {
      background: 'none'
    }
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getQuestion: question_id => dispatch( get_question(question_id) ),
    createQuestion: values => dispatch( create_question(values) ),
    updateQuestion: (question_id, values) => dispatch( update_question(question_id, values) ),
    getAudio: question_id => dispatch( question_audio(question_id) ),
    getImage: question_id => dispatch( question_image(question_id) ),
    uploadAudio: (values) => dispatch( upload_audio(values) ),
    uploadImage: (values) => dispatch( upload_image(values) ),
    resetQuestion: () => dispatch( reset_question() ),
    clearQuestion: () => dispatch( clear_question() ),
    trashQuestion: (id) => dispatch( trash_question(id) ),
    getPreferences: () => dispatch( preferences_index() ),
    resetProgress: () => dispatch( reset_progress() ),
    resetImage: () => dispatch( question_image_request() ),
    resetAudio: () => dispatch( question_audio_request() ),
  };
};

const mapStateToProps = (state) => {
  return {
    audio_data: state.question.audio_data,
    audio_source: state.question.audio_source,
    fetching_audio: state.question.fetching_audio,

    image_data: state.question.image_data,
    image_source: state.question.image_source,
    fetching_image: state.question.fetching_image,

    current_user: state.auth.current_user.data,
    question: state.question.question,
    fetching: state.question.fetching_single,
    errors: state.question.errors,
    mustRedirect: state.question.must_redirect,
    setStatus: state.question.set_status,
    skills: state.skill.items,
    competencies: state.competency.items,
    tags: state.tag.items,
    levels: state.preference.levels,
    seconds: state.preference.preferences.question_seconds,
    skillErrors: state.skill.errors,
    competencyErrors: state.competency.errors,
    progress: state.progress.progress
  };
}

class ConnectedQuestionForm extends React.Component {
  initialState = {
    // state
    needsReset: false,
    // dialogs
    showPreview: false,
    showDialog: false,
    showDuplicateDialog: false,
    // form
    answerAValid: true, answerBValid: true, answersNumber: 2, receivedAnswers: 0,
    rightAnswer: 0, useAnswers: [], answerIds: [],
    seconds: 0,
    bodyValid: true, bodyError: '',
    secondsValid: true,
    skillValid: true, skill: '',
    competencyValid: true, competency: '',
    levelValid: true, level: '',
    tags: [],
    formValid: false, formPristine: true, formData: null,
    questionType: null,
    // audio
    audio: null,
    audioFile: '',
    audioReady: false,
    audioValid: true,
    tempduration: 0,
    // image
    image: null,
    imageFile: '',
    imageReady: false,
    imageValid: true,
    // preview
    version: null,
    versionsOpen: false,
    staticQuestion: null,
    // data
    publish: false, trash: false, duplicate: false,
    group_id: null,
  }

  state = {
    ...this.initialState
  }

  attachDispatch(dispatch) {
    this.formDispatch = dispatch;
  }

  componentWillMount() {
    const actionName = this.props.match.path === '/questions/new' ? 'create' : 'update'

    this.setState({
      actionName: actionName
    })
    if ( actionName === "create") {
      this.props.clearQuestion()
    } else {
      const {question_id} = this.props.match.params

      if (this.props.question.id !== question_id) {
        this.props.resetQuestion()
        this.props.getQuestion(question_id)
      }
    }
    this.props.getPreferences()
  }

  componentDidUpdate(prevProps, prevState){
    const { question } = this.props

    const actionName = this.props.match.path === '/questions/new' ? 'create' : 'update'

    // Set Media Source
    if (actionName === 'update' && this.props.image_source !== null && this.state.image ===  null && !this.props.fetching_image ) {
      this.setState({image: this.props.image_source, imageReady: true, imageFile: this.props.image_data.filename})
    } else if (actionName === 'update' && this.props.audio_source !== null && this.state.audio ===  null && !this.props.fetching_audio ) {
      this.setState({audio: this.props.audio_source, audioReady: true, audioFile: this.props.audio_data.filename})
    }

    // Set Action Name
    if (actionName !== this.state.actionName) {
      return this.setState({ actionName: actionName })
    }

    // Reset question when coming from Edit Form
    if (this.state.actionName !== prevState.actionName && actionName === 'create') {
      this.props.clearQuestion()
      // return this.setState({ needsReset: true, useAnswers: [], answerIds: [] })
      this.setState({ ...this.initialState })
    }

    if (this.state.needsReset) {
      return this.setState({ needsReset: false})
    }

    const { useAnswers, receivedAnswers } = this.state

    if ( this.state.questionType === null && question.question_type !== undefined && question.question_type !== null ) {
      this.setState({
        questionType: question.question_type,
        tags: question.tags
      })
    }
    if (question.answers.number !== prevProps.question.answers.number && this.state.actionName === prevState.action) {
      return this.setState({receivedAnswers: question.answers.number})
    }


    if ( (actionName === "create" && useAnswers.length === 0) ||
         (actionName === "update" && receivedAnswers === 0 && question.answers.length > 0) ) {
      let newAnswers = []
      let newAnswerIds = question.answers.map( ans => ans.id )
      let newId
      for (let i=question.answers.length; i < 4; i++) {
        newId = shortid.generate()
        newAnswers.push({
          id: newId,
          body: '',
          right: false
        })
        newAnswerIds.push(newId)
      }
      const useAnswers = [
        ...question.answers,
        ...newAnswers
      ]
      this.setState({
        useAnswers: useAnswers,
        answersNumber: question.answers.length < 2 ? 2 : question.answers.length,
        skill: question.skill ? question.skill.id : '',
        competency: question.competency ? question.competency.id : '',
        level: question.level ? question.level.rank : '',
        receivedAnswers: question.answers.length,
        answerIds: newAnswerIds
      })
      if ( actionName === 'update' && question.seconds !== undefined && question.seconds!==null ) {
        this.setState({seconds: question.seconds || this.props.seconds})
      }
    }

    if (actionName === 'create' && this.state.seconds === 0 && this.props.seconds) {
      this.setState({seconds: this.props.seconds})
    }

    if ( actionName !== 'create') {

      const {question_id} = this.props.match.params

      if (question.id !== undefined && question.id !== question_id) {
        if (this.state.duplicate) {
          return this.setState({duplicate: false})
        } else {
          this.props.getQuestion(question_id)
        }

      } else if ( question && question.question_type === 'audio' && question.audio_file !== null && !this.props.fetching_audio && this.props.audio_source === null) {
        this.props.getAudio(question.id)
        this.setState({image: 'nofile', imageReady: true, imageFile: question.image_file || ''})

      } else if ( question && question.question_type === 'image' && question.image_file !== null && !this.props.fetching_image && this.props.image_source === null ) {
        this.props.getImage(question.id)
        this.setState({image: 'nofile', imageReady: true, imageFile: question.image_file || ''})

      } else if ( prevProps.audio_source !== this.props.audio_source && this.props.audio_source !== null) {
        this.setState({audio: this.props.audio_source, audioReady: true, audioFile: question.audio_file || ''})

      } else if ( prevProps.image_source !== this.props.image_source && this.props.image_source !== null) {
        this.setState({image: this.props.image_source, imageReady: true, imageFile: question.image_file || ''})
      }

      if (question && question.question_type === 'audio' && question.image_file !== null && !this.props.fetching_image && this.props.image_source === null && !this.state.image) {
        this.props.getImage(question.id)
        // this.setState({image: 'nofile', imageReady: true, imageFile: question.image_file || ''})
      } else if (question && question.question_type === 'audio' && question.image_file !== null && this.props.image_source === null && !this.state.image && !prevState.image ) {
        this.setState({image: this.props.image_source, imageReady: true, imageFile: question.image_file || ''})
      }

    } else {
      if (!prevProps.seconds && this.props.seconds) {
        this.formDispatch( actions.change('question.seconds', this.props.seconds) )
      }
    }

    if (this.props.mustRedirect && !prevProps.mustRedirect) {
      window.showSnackbar('success', 'Question has been saved.')
    }

    if ( this.props.audio_data.filename && this.props.audio_data.filename !== prevProps.audio_data.filename ) {
      this.setState({audioReady: true})
    }

    if ( this.props.image_data.filename && this.props.image_data.filename !== prevProps.image_data.filename ) {
      this.setState({imageReady: true})
    }

    if ( this.props.mustRedirect && actionName === "create" && this.props.question.id )  {
      this.setState({
        publish: this.state.publish,

        ...this.initialState
      })
    }

  }

  handleUploadAudio(model,values) {
    if (values !== null && values !== undefined && values.length !== 0) {
        const {size, type} = values[0]
      if (type && !/audio.*(mpeg|wav|mp3)/.test(type)) {
        // invalid type
        window.showSnackbar("error", "Upload failed. Audio file format not supported.")

      } else if ( size && size > 10*2**20 ) { // 10 MB
        // file is too big
        window.showSnackbar("error", "Upload failed, Audio file too large (Max File size 10MB).")

      } else if ( size && type ) {
        // ok, go ahead
        this.setState({audioReady: false})
        const formData = new FormData()
        formData.append('audio', values[0], values[0].name)
        // const { question_id } = this.props.match.params
        this.props.uploadAudio(formData)
        const source = URL.createObjectURL(values[0])
        this.setState({audio: source, audioFile: values[0].name, audioReady: false, audioValid: true})
      }
    }
  }

  handleDeleteAudio() {
    this.setState({audio: null, audioFile: '', audioReady: false, audioValid: false})
    this.props.resetProgress()
    this.props.resetAudio()
  }

  handleUploadImage(model,values) {
    if (values !== null && values !== undefined && values.length !== 0) {
        const {size, type} = values[0]
      if (type && !/image.*(png|jpeg|jpg|svg)/.test(type)) {
        // invalid type
        window.showSnackbar("error", "Upload failed. Image file format not supported.")

      } else if ( size && size > 2**20 ) { // 1 MB
        // file is too big
        window.showSnackbar("error", "Upload failed, Image file too large (Max File size 1MB).")

      } else if ( size && type ) {
        // ok, go ahead
        this.setState({imageReady: false})
        const formData = new FormData()
        formData.append('image', values[0], values[0].name)
        // const { question_id } = this.props.match.params
        this.props.uploadImage(formData)
        const source = URL.createObjectURL(values[0])
        this.setState({image: source, imageFile: values[0].name, imageReady: false, imageValid: true})
      }
    }
  }

  handleDeleteImage() {
    this.setState({image: null, imageFile: '', imageReady: false, imageValid: this.state.questionType==='audio'})
    this.props.resetProgress()
    this.props.resetImage()
  }

  handleSubmit(inValues) {

    const {answers, right, audio, image, ...other} = inValues
    const intRight = parseInt(right, 10)

    if (this.props.current_user.role === "admin" && this.state.skill === '') {
      return this.setState({skillValid: false})
    }
    if (this.props.current_user.role === "admin" && this.state.competency === '') {
      return this.setState({competencyValid: false})
    }

    const interimAnswers = answers.map( (ans, index) => {
      if (index === intRight) {
        return {
          right: true,
          body: ans.body
        }
      }
      return {
        body: ans.body
      }
    })

    const newAnswers = interimAnswers.filter( val => val.body !== undefined && val.body !== null && val.body !== '')

    let values
    values = {
      ...other,
      answers: newAnswers,
      tag_ids: this.state.tags.map( tag => tag.value )
    }
    if (this.state.publish) {
      values={
        ...values,
        publish: true,
        index: false
      }
    } else if (this.state.duplicate) {
      values={
        ...values,
        duplicate: true,
        index: false
      }
    }

    const actionName = this.props.match.path === '/questions/new' ? 'create' : 'update'

    if ( values.question_type === 'audio' ) {
      values = {
        ...values,
        audio_file_name: this.state.audioFile,
        image_file_name: this.state.imageFile
      }
      if (actionName === 'update') {
        if (this.props.audio_data && this.props.audio_data.filename !== this.props.question.audio_file) {
          values = {
            ...values,
            audio_file: this.props.audio_data.filename
          }
          if (this.props.image_data) {
            values = {
              ...values,
              image_file: this.props.image_data.filename
            }
          }
        }
      } else {
        values = {
          ...values,
          audio_file: this.props.audio_data.filename
        }
        if (this.props.image_data) {
          values = {
            ...values,
            image_file: this.props.image_data.filename
          }
        }
      }
    } else if ( values.question_type === 'image' ) {
      values = {
        ...values,
        image_file_name: this.state.imageFile
      }
      if (actionName === 'update') {
        if (this.props.image_data && this.props.image_data.filename !== this.props.question.image_file) {
          values = {
            ...values,
            image_file: this.props.image_data.filename
          }
        }
      } else {
        values = {
          ...values,
          image_file: this.props.image_data.filename
        }
      }
    }

    if (actionName === "create") {
      this.props.createQuestion(values)
    } else if (actionName !== "create"){
      const { question_id } = this.props.match.params
      this.props.updateQuestion(question_id, values)
    }

  }

  addAnswer() {
    const {answersNumber} = this.state
    if (answersNumber < 4) {
      this.setState({ answersNumber: answersNumber + 1 })
    }
  }

  removeAnswer(id, index=3) {

    const { answersNumber} = this.state

    if (index < 3) {
      this.formDispatch(actions.move('question.answers[]', index, 3))
      this.formDispatch(actions.setValidity(track('question.answers[].body', {id: id}), true))
    }

    this.formDispatch(actions.change(track('question.answers[].body', {id: id}), ''))

    this.setState({
      answersNumber: answersNumber - 1,
    })

    const ra = parseInt(this.state.rightAnswer, 10)
    const ind= parseInt(index, 10)
    if (ra === ind) {
      this.formDispatch(actions.change('question.right', "0"))
    } else if ( ra > ind ) {
      this.formDispatch( actions.change('question.right', (ra - 1).toString() ))
    }

  }

  checkValid() {
    const { answerIds } = this.state
    this.formDispatch( actions.setDirty('question.body') )
    this.formDispatch( actions.setDirty('question.seconds') )
    this.formDispatch( actions.setDirty( track('question.answers[].body', (answer) => answer && answer.id === answerIds[0]) ) )
    this.formDispatch( actions.setDirty( track('question.answers[].body', (answer) => answer && answer.id === answerIds[1]) ) )

    let skillValid = true
    if (this.props.current_user.role === 'admin' && this.state.skill === '') {
      skillValid = false
      this.setState({skillValid: false})
    }

    let competencyValid = true
    if (this.props.current_user.role === 'admin' && this.state.competency === '') {
      competencyValid = false
      this.setState({competencyValid: false})
    }

    let levelValid = true
    if (this.state.level === '') {
      levelValid = false
      this.setState({levelValid: false})
    }

    let audioValid = true
    if (this.state.questionType === 'audio' && this.state.audioFile === '')  {
      audioValid = false
      this.setState({audioValid: false})
    }

    let imageValid = true
    if (this.state.questionType === 'image' && this.state.imageFile === '')  {
      imageValid = false
      this.setState({imageValid: false})
    }

    const isValid = this.state.formData.$form.valid && skillValid && competencyValid && levelValid && audioValid && imageValid
    if (!isValid) {
      window.showSnackbar('error', 'Please fill in all mandatory fields.')
    }
    return isValid
  }

  handleUpdate(form) {
    const { body, answers, question_type, right, seconds } = form
    this.setState({formData: form})

    let newIds = []

    Object.keys(answers).forEach( key => {
      if (answers[key].id && answers[key].id.value) {
        newIds.push(answers[key].id.value)
      }
    })

    this.setState({
      rightAnswer: right.value,
      questionType: question_type.value
    })

    const answerA = answers[0]
    const answerB = answers[1]

    const bodyState = (body.pristine || body.valid)
    const secondsState = (seconds.pristine || seconds.valid)

    const answerAstate = (answerA.body.pristine || answerA.body.value !== '' )
    const answerBstate = (answerB.body.pristine || answerB.body.value !== '' )

    if (question_type.value !== 'audio') {
      this.setState({audioValid: true})
    }

    if (question_type.value !== 'image') {
      this.setState({imageValid: true})
    }

    let skillValid = true
    if (this.props.current_user.role === 'admin' && this.state.skill === '' ) {
      skillValid = false
    }

    let competencyValid = true
    if (this.props.current_user.role === 'admin' && this.state.competency === '' ) {
      competencyValid = false
    }

    let levelValid = true
    if (this.state.level === '' ) {
      levelValid = false
    }

    const formState = answerA.body.valid && answerB.body.valid && body.valid && right.valid && skillValid && competencyValid && levelValid

    this.setState({
      bodyValid: bodyState,
      secondsValid: secondsState,
      answerAValid: answerAstate,
      answerBValid: answerBstate,
      formValid: formState,
      answerIds: newIds,
      formPristine: form.pristine,
    })

  }

  handleTags = value => {
    this.setState({tags: value})
  }

  handleChange(e) {
    const { value } = e.target
    this.formDispatch(actions.change('question.skill', value))
    this.setState({skill: value, skillValid: ( value && value !== '' )})
  }

  handleChangeCompetency(e) {
    const { value } = e.target
    this.formDispatch(actions.change('question.competency', value))
    this.setState({competency: value, competencyValid: ( value && value !== '' )})
  }

  handleChangeLevel(e) {
    const { value } = e.target
    this.formDispatch(actions.change('question.level', value))
    this.setState({level: value, levelValid: ( value && value !== '' )})
  }

  handleChangeSeconds(e) {
    const { value } = e.target
    this.formDispatch(actions.change('question.seconds', value))
    this.setState({seconds: value})
  }

  handleTrash() {
    const {question_id} = this.props.match.params
    this.setState({trash: true, showDialog: false, showDuplicateDialog: false})
    this.props.trashQuestion(question_id)
  }

  hideDialog() {
    this.setState({showDialog: false, showDuplicateDialog:false, showPreview: false, version: null, staticQuestion: null})
  }

  handlePublish() {
    this.props.resetQuestion()
    this.setState({publish: true, showDialog: false, showDuplicateDialog: false})
    this.formDispatch(actions.submit('question'))
  }

  handleDuplicate() {
    this.setState({duplicate: true, showDialog: false, showDuplicateDialog: false})
    this.formDispatch(actions.submit('question'))
  }

  openVersions() {
    this.setState({ versionsOpen: !this.state.versionsOpen})
  }

  questionPreview() {
    let setObject = {}
    if (this.state.formData === null) {
      setObject={
        instructions: this.props.question.instructions,
        body: this.props.question.body,
        answers: this.props.question.answers,
        tags: this.props.question.tags,
        skill: this.props.question.skill,
        competency: this.props.question.competency,
        seconds: this.props.question.seconds,
        level: this.props.question.level,
        question_type: this.props.question.question_type
      }
    } else {
      const { instructions, body, right, answers, level, seconds, question_type } = this.state.formData
      const ansValues = ["0", "1", "2", "3"].filter( o => answers[o].body.value !== '' ).map( o => {
        return {body: answers[o].body.value, right: `${o}` === `${right.value}`}
      } )
      setObject={
        instructions: instructions.value,
        body: body.value,
        answers: ansValues || [],
        tags: this.state.tags,
        skill: this.props.skills.find( s => s.id === this.state.skill ),
        competency: this.props.competencies.find( s => s.id === this.state.competency ),
        level: level ? this.props.levels.find( l => l.rank === level.value) : {},
        seconds: seconds ? seconds.value : undefined,
        question_type: question_type ? question_type.value : "",
      }
    }
    setObject = {
      ...setObject,
      audio: this.state.audio,
      image: this.state.image
    }
    this.setState({showPreview: true, version: null, staticQuestion: setObject})
  }

  render() {

    if ( !is_logged_on() && !is_validating() ) {
      return <Redirect to="/" />
    }

    const { current_user, skills, competencies, levels } = this.props

    if ( ["creator", "expert", "admin"].indexOf(this.props.current_user.role) < 0 ) {
      return <Redirect to="/" />
    }

    const {
      id, active, instructions, body, skill, competency,
      question_type, creator, modifier, trash,
      versions, created_at, updated_at, seconds, level,
      group_id
    } = this.props.question

    const { mustRedirect, fetching, setStatus, question } = this.props

    const actionName = this.props.match.path === '/questions/new' ? 'create' : 'update'

    const { answersNumber, useAnswers, answerIds, publish, duplicate } = this.state

    if (mustRedirect && publish) {
      window.showSnackbar('success', 'The question status has changed to: Published.')
      return (
        <Redirect to="/questions" />
      )
    } else if ( actionName === 'update' && mustRedirect && duplicate && question && question.id !== this.props.match.params.question_id ) {
      window.showSnackbar('success', 'You have now switched to editing the new copy of the question.')
      return (
        <Redirect to={`/questions/${question.id}/edit`} />
      )
    } else if ( mustRedirect && actionName === "create" && question.id ) {
      return (
        <Redirect to={`/questions/${question.id}/edit`} />
      )
    } else if (setStatus && this.state.trash) {
      return (
        <Redirect to="/questions" />
      )
    }

    if (fetching || useAnswers.length < 4 || this.state.needsReset ) {
      return ''
    }

    const rightAnswer = useAnswers.findIndex( ans => ans.right === true )

    let initialState = {
      instructions: instructions || '',
      body: body  || '',
      answers: useAnswers,
      right: (rightAnswer > 0) ? rightAnswer.toString() : "0",
      question_type: question_type || 'text',
      seconds: seconds || '',
      level: level ? level.rank : '',
      group_id: group_id || '',
    }
    if (current_user.role === 'admin') {
      initialState = {
        ...initialState,
        skill: skill ? skill.id  : '',
        competency: competency ? competency.id  : '',
      }
    }

    const bodyLabel  = 'Required Field *'
    const bodyLabel2  = 'Required Field. To create gaps use [1]-[5] *'
    const bodyHelper = this.state.bodyValid ? bodyLabel : `${bodyLabel} ${this.state.bodyError}`
    const bodyHelper2 = this.state.bodyValid ? bodyLabel2 : `${bodyLabel2} ${this.state.bodyError}`

    const actionButtons = (
      <div className="d-flex">
        <CustomOutlinedButton
          className="buttonnoto c-blue align-self-center mr-16"
          onClick={e => {
            e.preventDefault()
            this.setState({publish: false, trash: false})
            if (this.checkValid()) {
              this.formDispatch( actions.submit('question'))
            }
          }}>Save</CustomOutlinedButton>
      </div>
    )

    return (
      <MuiThemeProvider theme={theme}>

          <Grid container spacing={24} justify="space-between">
            <Grid item xs={12} md={8} className="will-change9">

              <div className="d-flex justify-content-between mb-40">

                <Typography className="fw-bold h4">
                Question
                </Typography>

                { actionButtons }

              </div>

            </Grid>

            <Grid item xs={12} md={8} className="will-change9">

                <LocalForm
                  model="question"
                  className="collection-item"
                  initialState={initialState}
                  getDispatch={(dispatch) => this.attachDispatch(dispatch)}
                  ref="Lform"
                  onUpdate={this.handleUpdate.bind(this)}
                  onSubmit={this.handleSubmit.bind(this)}
                >

                  <Paper use="skill_type" className="mb-24 innerbar">
                    <InnerBar text="Question Settings" />
                    <div className="pl-24 pr-24 pt-24 pb-24 d-flex flex-wrap align-items-center">
                      <Grid container>
                          <Grid container item xs={12} md={12} spacing={0}>
                            <Grid item className="customFormControlSelectWrapper">
                              {
                                (current_user.role === "admin" && skills.length > 0) ? (
                                  <React.Fragment>
                                    <Typography className="h6 mb-8">Skill</Typography>
                                    <Control.select
                                      model="wah"
                                      id="question-skill"
                                      value={this.state.skill}
                                      label="Select Skill *"
                                      component={FormSelect}
                                      required
                                      error={!this.state.skillValid}
                                      helperText={this.state.skillValid ? '' : 'Skill is required'}
                                      className="body2 customFormControlSelect"
                                      onChange={(e) => this.handleChange(e)}
                                      validators={{
                                        required: (val) => {
                                          return isRequired(val)
                                        }
                                      }}

                                    >
                                    {
                                      skills.map( skill => {
                                        return <MenuItem key={skill.id} value={skill.id}>{skill.name}</MenuItem>
                                      })
                                    }
                                    </Control.select>
                                  </React.Fragment>
                                ) : (
                                  <React.Fragment>
                                    <Typography className="h6 mb-8">Skill</Typography>
                                    <FormControl className="body2">
                                      <InputLabel>Select Skill *</InputLabel>
                                      <Select style={{width:'150px'}} readOnly={true} value={current_user.skill ? current_user.skill.name : ''}>
                                        <MenuItem value={current_user.skill ? current_user.skill.name : ''}>{current_user.skill ? current_user.skill.name : ''}</MenuItem>
                                      </Select>
                                    </FormControl>
                                  </React.Fragment>
                                )
                              }
                            </Grid>

                            <Grid item className="customFormControlSelectWrapper">
                              {
                                (competencies.length > 0) && (
                                  <React.Fragment>
                                    <Typography className="h6 mb-8">Competency</Typography>
                                    <Control.select
                                      model="wah"
                                      id="question-competency"
                                      value={this.state.competency}
                                      label="Select Competency *"
                                      component={FormSelect}
                                      required
                                      error={!this.state.competencyValid}
                                      helperText={this.state.competencyValid ? '' : 'Competency is required'}
                                      className="body2 customFormControlSelect"
                                      onChange={(e) => this.handleChangeCompetency(e)}
                                      validators={{
                                        required: (val) => {
                                          return isRequired(val)
                                        }
                                      }}

                                    >
                                    {
                                      competencies.map( competency => {
                                        return <MenuItem key={competency.id} value={competency.id}>{competency.name}</MenuItem>
                                      })
                                    }
                                    </Control.select>
                                  </React.Fragment>
                                )
                              }
                            </Grid>

                            <Grid item className="customFormControlSelectWrapper">
                              {
                                // CEFR LEVEL

                                levels && (
                                <React.Fragment>
                                  <Typography className="h6 mb-8">CEFR</Typography>
                                  <Control.select
                                    model="asdf"
                                    id="question-level"
                                    value={this.state.level}
                                    label="Select Level *"
                                    component={FormSelect}
                                    required
                                    error={!this.state.levelValid}
                                    helperText={this.state.levelValid ? '' : 'Level is required'}
                                    className="body2 customFormControlSelect"
                                    onChange={(e) => this.handleChangeLevel(e)}
                                    validators={{
                                      required: (val) => {
                                        return isRequired(val)
                                      }
                                    }}

                                  >
                                  {
                                    levels.map( level => {
                                      return <MenuItem key={level.rank} value={level.rank}>{level.name}</MenuItem>
                                    })
                                  }
                                  </Control.select>
                                </React.Fragment>
                              )

                              }
                            </Grid>

                            <Grid item className="customFormControlSelectWrapper">

                              <Typography className="h6 mb-8">Exp. Time</Typography>
                              <Control.select
                                model="qsqs"
                                id="question-seconds"
                                value={this.state.seconds}
                                label="Select Exp. Time *"
                                component={FormSelect}
                                required
                                error={!this.state.secondsValid}
                                onChange={(e) => this.handleChangeSeconds(e)}
                                helperText={this.state.secondsValid ? '' : 'Exp. Time is required'}
                                className="body2 customFormControlSelect"
                                validators={{
                                  required: (val) => {
                                    return isNumeric(val)
                                  }
                                }}

                              >
                              {
                                [15, 20, 25, 30, 35, 40, 45, 50, 55, 60].map( unit => {
                                  return <MenuItem key={unit} value={unit}>{unit}</MenuItem>
                                })
                              }
                              </Control.select>

                            </Grid>

                          </Grid>

                        <Grid container item xs={12} md={12}>

                          <Grid item style={{marginRight: 24}}>
                            <Typography className="h6 mt-40 mb-8">Type</Typography>

                              <div style={{transform: 'translateX(-16px)'}}>
                                <Control.radio
                                  component={StyledRadio}
                                  model="question.question_type"
                                  value="text"
                                  color="default"
                                  label="Text"
                                  aria-label="Text"
                                  className="subtitle1 no-margin"
                                />

                                <Control.radio
                                  component={StyledRadio}
                                  model="question.question_type"
                                  value="image"
                                  color="default"
                                  label="Image"
                                  aria-label="Image"
                                  error={!this.state.imageValid}
                                  className="subtitle1 no-margin"
                                />

                                <Control.radio
                                  component={StyledRadio}
                                  model="question.question_type"
                                  value="audio"
                                  color="default"
                                  label="Audio"
                                  aria-label="Audio"
                                  error={!this.state.audioValid}
                                  className="subtitle1 no-margin"
                                />

                              </div>
                            </Grid>

                            <Grid item>
                              <Typography className="h6 mt-40">Sibling ID</Typography>
                              <TextInput
                                id="question-group_id"
                                model="question.group_id"
                                multiline={true}
                                placeholder="Family Sibling ID"
                                InputProps={{style: {padding: 0}}}
                              />
                            </Grid>
                        </Grid>


                      </Grid>

                    </div>
                  </Paper>

                  <Paper use="question body" className="mb-24 innerbar">
                    <InnerBar text="Question Data" />
                    <div className="pl-24 pr-24 pt-24 pb-24">
                      <Typography className="h6 mb-8">Text Data</Typography>
                      <TextInput
                        id="question-body"
                        model="question.body"
                        multiline={true}
                        required
                        placeholder="Text question goes here."
                        error={!this.state.bodyValid}
                        helperText={bodyHelper2}
                        validators={{
                          required: (val) => {
                            return isRequired(val)
                          }
                        }}
                      />

                    </div>

                      {
                        this.state.questionType !== 'text' && (
                        // this.state.questionType === 'image' && (
                          <ImageSubForm
                            progress={this.props.progress}
                            imageReady={this.state.imageReady}
                            image={this.state.image}
                            imageValid={this.state.imageValid}
                            imageFile={this.state.imageFile}
                            handleDeleteImage={this.handleDeleteImage.bind(this)}
                            handleUploadImage={this.handleUploadImage.bind(this)}
                          />
                        )
                      }

                      {
                        this.state.questionType === 'audio' && (
                          <AudioSubForm
                            progress={this.props.progress}
                            audioReady={this.state.audioReady}
                            audio={this.state.audio}
                            audioValid={this.state.audioValid}
                            audioFile={this.state.audioFile}
                            tempduration={this.state.tempduration}
                            handleDeleteAudio={this.handleDeleteAudio.bind(this)}
                            handleUploadAudio={this.handleUploadAudio.bind(this)}
                          />
                        )
                      }

                  </Paper>

                  <Paper use="answers" className="mb-24 innerbar">
                    <InnerBar text="Answer Data" />
                    <div className="pl-24 pr-24 pt-24 pb-24">
                      <div className="d-flex justify-content-end correct caption c-black087">Correct</div>
                      <div className="d-flex">
                        <div className="flex-1">
                          <TextInput
                            id="question-answerA"
                            model={track('question.answers[].body', (answer) => answer && answer.id === answerIds[0])}
                            multiline={true}
                            rowsMax={6}
                            required
                            helperText="Required Field"
                            placeholder="Write an answer"
                            error={!this.state.answerAValid}

                          />
                        </div>
                        {
                          answersNumber > 2 ? (
                            <div className="align-self-center">
                              <IconButton
                                onClick={e=>{
                                  e.preventDefault()
                                  this.removeAnswer(answerIds[0],0)
                              }}>
                                <Icon style={{color: 'black'}}>delete_forever</Icon>
                              </IconButton>
                            </div>
                          ) : (
                            <div className="align-self-center">
                              <Icon color="disabled">delete_forever</Icon>
                            </div>
                          )
                        }
                        <Control.radio
                            component={StyledRadio}
                            model="question.right"
                            value="0"
                            color="default"
                            aria-label="A"
                            labelPlacement="end"
                            className="no-margin"
                        />
                      </div>

                      <div className="d-flex">
                        <div className="flex-1">
                          <TextInput
                            id="question-answerB"
                            model={track('question.answers[].body', (answer) => answer && answer.id === answerIds[1])}
                            multiline={true}
                            rowsMax={6}
                            required
                            helperText="Required Field"
                            placeholder="Write an answer"
                            error={!this.state.answerBValid}
                            validators={{
                              required: (val) => {
                                return isRequired(val)
                              }
                            }}
                          />
                        </div>
                        {
                          answersNumber > 2 ? (
                            <div className="align-self-center">
                              <IconButton
                                onClick={e=>{
                                  e.preventDefault()
                                  this.removeAnswer(answerIds[1],1)
                              }}>
                                <Icon style={{color: 'black'}}>delete_forever</Icon>
                              </IconButton>
                            </div>
                          ) : (
                            <div className="align-self-center">
                              <Icon color="disabled">delete_forever</Icon>
                            </div>
                          )
                        }
                        <Control.radio
                          component={StyledRadio}
                          model="question.right"
                          value="1"
                          color="default"
                          aria-label="B"
                          labelPlacement="end"
                          className="no-margin"
                        />
                      </div>

                      {
                        answersNumber > 2 && (
                          <div className="d-flex">
                            <div className="flex-1">
                              <TextInput
                                id="question-answerC"
                                model={track('question.answers[].body', (answer) => answer && answer.id === answerIds[2])}
                                multiline={true}
                                rowsMax={6}
                                placeholder="Write an answer"
                                helperText={bodyHelper}
                              />
                            </div>
                            <div className="align-self-center">
                              <IconButton
                                onClick={e=>{
                                  e.preventDefault()
                                  this.removeAnswer(answerIds[2],2)
                              }}>
                                <Icon style={{color: 'black'}}>delete_forever</Icon>
                              </IconButton>
                            </div>
                            <Control.radio
                              component={StyledRadio}
                              model="question.right"
                              value="2"
                              color="default"
                              aria-label="C"
                              labelPlacement="end"
                              className="no-margin"
                            />
                          </div>

                        )
                      }

                      {
                        answersNumber > 3 && (
                          <div className="d-flex">
                            <div className="flex-1">
                              <TextInput
                                id="question-answerC"
                                model={track('question.answers[].body', (answer) => answer && answer.id === answerIds[3])}
                                multiline={true}
                                rowsMax={6}
                                placeholder="Write an answer"
                                helperText={bodyHelper}
                              />
                            </div>
                            <div className="align-self-center">
                              <IconButton
                                onClick={e=>{
                                  e.preventDefault()
                                  this.removeAnswer(answerIds[3],3)
                              }}>
                                <Icon style={{color: 'black', cursor: 'pointer'}}>delete_forever</Icon>
                              </IconButton>
                            </div>
                            <Control.radio
                              component={StyledRadio}
                              model="question.right"
                              value="3"
                              color="default"
                              aria-label="D"
                              labelPlacement="end"
                              className="no-margin"
                            />
                          </div>
                        )
                      }

                      {
                        answersNumber < 4 && (
                          <div>
                            <div className="d-flex justify-content-end mt-12">
                            <CustomOutlinedButton className="buttonnoto c-blue" onClick={ e => {
                              e.preventDefault()
                              this.addAnswer()
                            }}
                            >Add Answer</CustomOutlinedButton>
                            </div>
                          </div>
                        )
                      }
                  </div>
                </Paper>

                <Paper use="instructions" className="innerbar">
                  <InnerBar text="Instructions" />
                  <div className="pl-24 pr-24 pt-24 pb-24">
                    <TextInput
                      id="question-instructions"
                      model="question.instructions"
                      rowsMax={6}
                      placeholder="Special Instructions go here"
                      multiline={true}
                      helperText="Optional Field"
                    />
                  </div>
                </Paper>

              </LocalForm>

              <Hidden smDown>
                <div className="d-flex justify-content-end mt-40">
                  { actionButtons }
                </div>
                </Hidden>

            </Grid>

            <Grid use="meta" item xs={12} md={4} className="will-change3">

                <Paper>
                  <div className="bg-white">
                    { actionName !== "create" && (
                      <React.Fragment>
                        <div use="meta" className="pt-24 pb-24 pr-24 pl-24">
                          <MetaBox
                            title="Status"
                            value={active ? 'Published ' : trash ? "In Trash " : "Draft "}
                          />

                          {
                            current_user.role !== 'creator' && (
                              <MetaBox
                                title="Created by"
                                value={creator.display_name}
                              />
                            )
                          }

                          <MetaBox
                            title="Created on"
                            value={new Date(created_at).toLocaleString()}
                          />
                          {
                            modifier && (
                              <React.Fragment>
                                <MetaBox
                                  title="Modified by"
                                  value={(modifier && modifier.display_name) || creator.display_name}
                                />
                                <MetaBox
                                  title="Modified on"
                                  value={new Date(updated_at).toLocaleString()}
                                />
                              </React.Fragment>
                            )
                          }

                          {
                            current_user.role === 'admin' && (
                              <React.Fragment>
                                <MetaBox
                                  title="Skill"
                                  value={skill.name}
                                />
                                <MetaBox
                                  title="Competency"
                                  value={competency.name}
                                />
                              </React.Fragment>
                            )
                          }
                          <MetaBox
                            title="ID"
                            value={id}
                          />
                          <MetaBox
                            title="Sibling ID"
                            value={group_id}
                          />

                        </div>
                        <Divider className="bg-divider" />
                      </React.Fragment>
                    )}

                    <div className="bg-white">
                      <div className="pt-24 pb-24 pr-24 pl-24">
                      <div className="fw-bold body2">Actions:</div>
                       {
                            !active && !trash && (
                              <React.Fragment>

                                <Link className="c-black087 body2 d-block mb-8 mt-8" to='' onClick={e=> {
                                    e.preventDefault()
                                    this.questionPreview()
                                }}>Preview</Link>

                                {
                                  (current_user.role === "admin" || current_user.role === "expert") && (
                                    <Link className="c-black087 body2 d-block mb-8" to='' onClick={e=>{
                                        e.preventDefault()
                                        if (this.checkValid()) {
                                          this.setState({showDialog:true})
                                        }
                                    }}>Publish</Link>
                                  )
                                }

                                <Link className="c-black087 body2 d-block mb-8" to='' onClick={e=>{
                                    e.preventDefault()
                                    if (this.checkValid()) {
                                      this.setState({showDuplicateDialog:true})
                                    }
                                }}>Duplicate</Link>

                                <Link className="c-black087 body2" to='' onClick={e=> {
                                    e.preventDefault()
                                    this.handleTrash()
                                }}>Move to Trash</Link>

                              </React.Fragment>
                            )
                          }

                      </div>
                    </div>
                    <Divider className="bg-divider" />

                    <div use="tags" className="tags-wrapper pt-24 pb-24 pr-24 pl-24">
                      <div className="fw-bold mb-8 body2">Tags:</div>
                      <MultiSelect
                        placeholder="add tags"
                        value={this.state.tags}
                        handleChange={this.handleTags.bind(this)}
                        helperText="Type or chose from menu"
                        suggestions={
                          this.props.tags.map( tag => {
                            return {
                              value: tag.id,
                              label: tag.name
                            }
                          })
                        }
                      />
                    </div>

                    {
                      actionName !== "create" && versions !== undefined && versions.length > 0 && (
                        <div>
                            <Divider className="bg-divider" />
                            <List className="sidebar-list sidebar-right" disablePadding={true}>
                              <ListItem
                                button
                                onClick={this.openVersions.bind(this)} style={localstyles.listItems}
                                className={this.state.versionsOpen ? "items is_current" : "items"}>
                                <ListItemText inset primary="Versions" className="spans" />
                                {this.state.versionsOpen ? <ExpandLess /> : <ExpandMore />}
                              </ListItem>
                              <Collapse in={this.state.versionsOpen} timeout="auto" unmountOnExit>
                                <List disablePadding>
                                  {
                                    versions.map(version => {
                                      return (
                                        <div key={version.id}>

                                        <ListItem key={version.id} className="pt-24 pb-32">
                                          <div>

                                            <MetaBox
                                              title="User"
                                              value={version.creator}
                                            />
                                            <MetaBox
                                              title="Published on"
                                              value={new Date(version.published_at).toLocaleString()}
                                            />
                                            <MetaBox
                                              title="Published by"
                                              value={version.publisher}
                                            />

                                            <div className="d-flex align-items-center">
                                              <Link className="c-black087 body2 t-decoration-underline mr-4" to='' onClick={e=>{
                                                  e.preventDefault()
                                                  this.setState({showPreview: true, version: version, staticQuestion: null})
                                                }}>Preview version
                                              </Link>
                                              <Icon style={{color: 'rgba(0,0,0,0.54)', fontSize: '16px'}}>remove_red_eye</Icon>
                                            </div>
                                          </div>
                                        </ListItem>
                                        <Divider className="bg-divider" />
                                        </div>
                                      )
                                    })
                                  }

                                </List>
                              </Collapse>
                            </List>
                        </div>

                      )
                    }
                    </div>
                  </Paper>

                  <Hidden mdUp>
                    <div className="d-flex justify-content-end mt-40">
                      { actionButtons }
                    </div>
                  </Hidden>

                  <CustomDialog
                    id={`publish-dialog`}
                    qid={this.props.match.params.question_id}
                    isopen={this.state.showDialog}
                    handleClose={this.hideDialog.bind(this)}
                    handleAccept={this.handlePublish.bind(this)}
                    fullScreen = {false}
                    title={`Publish Question?`}
                  >
                    Do you want to save changes and publish this question?
                  </CustomDialog>
                  {
                    <CustomDialog
                      id={`duplicate-dialog`}
                      qid={this.props.question.id}
                      isopen={this.state.showDuplicateDialog}
                      handleClose={this.hideDialog.bind(this)}
                      handleAccept={this.handleDuplicate.bind(this)}
                      fullScreen = {false}
                      title={`Duplicate Question?`}
                    >
                      Do you want to save changes and duplicate this question?
                    </CustomDialog>
                  }

                </Grid>
            <QuestionPreview
              id="preview-dialog"
              isopen={this.state.showPreview}
              version={this.state.version}
              staticQuestion={this.state.staticQuestion}
              handleClose={this.hideDialog.bind(this)}
            />
          </Grid>

      </MuiThemeProvider>
    )
  }
}

const QuestionForm = connect(mapStateToProps, mapDispatchToProps)(ConnectedQuestionForm);

export default QuestionForm



// WEBPACK FOOTER //
// ./src/js/components/QuestionForm.js